/* eslint-disable local/no-raw-colors */
import React from 'react'
import type { SvgProps } from 'react-native-svg'
import { ClipPath, Defs, G, Path, Rect, Svg } from 'react-native-svg'

export const ChartFwpYellow: React.FC<SvgProps> = props => (
    <Svg viewBox='0 0 32 32' {...props}>
        <G clipPath='url(#clip0_10859_99526)'>
            <Path
                d='M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z'
                fill='#606063'
            />
            <Path
                d='M9.133 16.514H5.758V20H4V11.469H9.555V12.893H5.758V15.096H9.133V16.514ZM17.219 17.539L18.367 11.469H20.119L18.227 20H16.457L15.068 14.293L13.68 20H11.91L10.018 11.469H11.77L12.924 17.527L14.33 11.47H15.818L17.218 17.54L17.219 17.539ZM22.826 16.994V20H21.068V11.469H24.396C25.037 11.469 25.601 11.586 26.086 11.82C26.573 12.055 26.947 12.388 27.209 12.82C27.471 13.251 27.602 13.742 27.602 14.293C27.602 15.129 27.315 15.788 26.743 16.271C26.171 16.753 25.379 16.994 24.367 16.994H22.826ZM22.826 15.57H24.396C24.861 15.57 25.216 15.46 25.46 15.242C25.704 15.023 25.826 14.711 25.826 14.305C25.826 13.887 25.703 13.549 25.457 13.291C25.211 13.033 24.871 12.901 24.437 12.893H22.827L22.826 15.57Z'
                fill='#F8D41D'
            />
        </G>
        <Defs>
            <ClipPath id='clip0_10859_99526'>
                <Rect fill='white' />
            </ClipPath>
        </Defs>
    </Svg>
)
